import { render, staticRenderFns } from "./AddItemButton.vue?vue&type=template&id=dff0992e&scoped=true"
import script from "./AddItemButton.vue?vue&type=script&lang=js"
export * from "./AddItemButton.vue?vue&type=script&lang=js"
import style0 from "./AddItemButton.vue?vue&type=style&index=0&id=dff0992e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff0992e",
  null
  
)

export default component.exports